var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8636_18781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4208 11.8493L11.4938 10.7757C13.2715 8.99692 13.2715 6.1129 11.4938 4.3341C9.71613 2.5553 6.83388 2.5553 5.05619 4.3341L2.91032 6.4813C1.13263 8.26012 1.13263 11.1441 2.91032 12.9229C3.73472 13.7478 4.79665 14.1901 5.87579 14.25",
    stroke: "#1C274C",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.744 11.5187C18.5217 9.73988 18.5217 6.85589 16.744 5.07709C15.9196 4.25218 14.8576 3.80982 13.7785 3.75M14.5981 13.6659C12.8204 15.4447 9.93816 15.4447 8.16051 13.6659C6.38282 11.8871 6.38282 9.00308 8.16051 7.22429L9.23346 6.15069",
    stroke: "#1C274C",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8636_18781"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.827148)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon_copy.100df2768c451540b1752e236816d5f6.svg";
export { ForwardRef as ReactComponent };